// Announces the Mac Printer Driver to Mac users on landing (ENG-3479).
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox } from 'antd';

import ModalWrapper from './ModalWrapper';
import DownloadApp from '../../assets/img/download_app.gif';
import { openPrinterDriverDownload } from '../../util/printerDriverDownload';
import { dismissMacPrinterDriverAnnouncement } from '../../util/macPrinterDriverAnnouncement';
import { captureAnalytics } from '../../actions/preload';

const pStyle = {
  textAlign: 'center',
  fontWeight: '600',
};

class MacPrinterDriverAnnouncement extends Component {
  constructor(props) {
    super(props);
    this.state = { doNotShowAgain: true };
  }

  // Every way out (Close, the X, the mask, installing) honours the checkbox.
  close = () => {
    const { hideModal } = this.props;
    const { doNotShowAgain } = this.state;
    if (doNotShowAgain) dismissMacPrinterDriverAnnouncement();
    hideModal();
  };

  install = () => {
    captureAnalytics('mac_printer_driver_announcement_download_clicked');
    openPrinterDriverDownload();
    this.close();
  };

  render() {
    const { doNotShowAgain } = this.state;

    return (
      <ModalWrapper
        hideModal={this.close}
        customContentStyle={{ width: '440px' }}
        dismiss="Close"
      >
        <p style={pStyle}>The Medsender Printer Driver is now available for Mac</p>
        <p>
          Install Medsender as a printer on your Mac (macOS 12 or later) to &lsquo;print&rsquo; any
          file straight to Medsender.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <img src={DownloadApp} style={{ height: '207px', margin: '0 auto' }} alt="Download Application" />
          <Button type="primary" style={{ margin: '10px 0' }} onClick={this.install}>
            Download for Mac
          </Button>
        </div>
        <Checkbox
          checked={doNotShowAgain}
          onChange={(event) => this.setState({ doNotShowAgain: event.target.checked })}
        >
          Don&apos;t show this to me again
        </Checkbox>
      </ModalWrapper>
    );
  }
}

MacPrinterDriverAnnouncement.propTypes = {
  hideModal: PropTypes.func.isRequired,
};

export default MacPrinterDriverAnnouncement;
